import styled from "@emotion/styled";
import { GhostButton } from "src/components/Buttons";

export const DropdownContainer = styled.div<{ show: boolean }>`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(220, 223, 228, 1);
  border-radius: 12px;
  box-shadow:
    0px 2px 8px rgba(0, 0, 0, 0.06),
    0px 16px 64px -12px rgba(0, 0, 0, 0.1);
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  padding: 6px;
  position: absolute;
  top: 42px;
  left: 0px;
  width: max-content;
  z-index: 1;
`;

export const DropdownRowButton = styled(GhostButton)`
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-transform: capitalize;
`;
